<template>
	<div class="home">
		<div class="Navbar">
			<div class="g-header">
				<div class="navleft">

					<div style="font-size: 20px;">Fg</div>

				</div>
				<div class="middle fs-18"></div>

			</div>
			<div class="block"></div>
		</div>
		<div class="g-content flex-column">
			<div class="mescroll">
				<!-- 轮播 -->
				<div> <img src="@/assets/home/3.jpg" alt="" /></div>
				<!-- 横向滑动 -->

				<div style="padding: 10px;">
					<div class="text-center " style="border: 1px solid rgb(184, 167, 138); border-radius: 5px; ">
						<lt-list></lt-list>
					</div>
				</div>
				<!-- 资产 -->
				<div class="cont-head">
					<div class="cont-left" @click="changeper">
						<div style="text-align: center;">
							<img src="@/assets/home/29.png" class="icon" alt="" />
							<div class="en-text">{{ $t("zican") }}</div>
							<div class="left-text">
								{{ money ? money : $t("deglu") }}
							</div>
						</div>

					</div>
					<!-- 					<div class="cont-right" @click="changeNews"> -->
					<div class="cont-right" @click="handleKefuClick">
						<div class="huobin">
							<img src="@/assets/home/30.png" class="rightcion" alt="" />
							<div style="  font-size: 12px; line-height: 40px; color: rgb(184, 167, 138);">
								{{ $t("zaixian") }}
							</div>
						</div>
					</div>
				</div>
				<div class="broadcast">
					<div class="broadcast-icon">
						<div class="sprite-icon_gonggao"></div>
					</div>
					<div class="oadcast">
						<div class="c_a0a0a0"><b>{{ $t("dangqianbanben") }}</b></div>
					</div>
				</div>

				<!---横线块无颜色 -->
				<!-- 			<div class="menu-container"></div> -->
				<!-- 跑马灯 -->
				<div style="padding: 10px;">
					<div class=" text-center " style="border: 1px solid rgb(184, 167, 138); border-radius: 5px; ">
						<div class="prize-news-wrap">
							<div class="sub-title">
								<span>{{ $t("jiaoyiyonghu") }}</span>
								<span>{{ $t("jiaoyipinglei") }}</span>
								<span>{{ $t("danlunhuoli") }}</span>
								<span>{{ $t("jiaoyiriqi") }}</span>
							</div>
							<div class="prize-news">
								<vue-seamless-scroll class="vux-marquee prize-marquee" :class-option="classOption"
									:data="infoList">
									<ul class="vux-marquee-box">
										<li class="prize-marquee-item" v-for="(item, index) in infoList" :key="index">
											<span class="name">{{ item.nickname }}</span>
											<span class="type">{{ ['NA SDAQ', 'USA', 'LDN'][index % 3] }}</span>
											<span class="money">{{ item.quantity }}</span>
											<span class="date">{{time}}</span>
										</li>
									</ul>
								</vue-seamless-scroll>
							</div>
						</div>
					</div>
				</div>
				<tab-bar></tab-bar>
				<!-- 线路遮罩层 -->
				<van-overlay v-model:show="showList" @click="showList = false">
					<div class="content">
						<ul class="line-content">
							<li class="line-item boderBottom" @click="activechange(0)">
								<p>{{ $t("xianlu") }}1</p>
								<img src="@/assets/image/gou.png" class="icon" alt="" v-if="activeList == 0" />
							</li>
							<li class="line-item boderBottom" @click="activechange(1)">
								<p>
									{{ $t("xianlu") }}2
									<span style="color: green">({{ $t("zuiyou") }})</span>
								</p>
								<img src="@/assets/image/gou.png" class="icon" alt="" v-if="activeList == 1" />
							</li>
						</ul>
					</div>
				</van-overlay>
			</div>
		</div>

		<!-- <div style="height:50px"></div> -->
	</div>
</template>

<script>
	// @ is an alias to /src
	import TabBar from "@/components/tabbar/TabBar.vue";
	import LtList from "@/components/ltlist/LtList.vue";

	import homeApi from "@/api/home";
	import vueSeamlessScroll from "vue-seamless-scroll/src";
	import storeAction from "@/store/typed-actions";
	export default {
		name: "Home",
		components: {
			TabBar,

			LtList,
			vueSeamlessScroll,
		},
		computed: {
			classOption() {
				return {
					step: 1, // 数值越大速度滚动越快
					// limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: false, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					// openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000, // 单步运动停止的时间(默认值1000ms)

				};
			},
			money() {
				// console.log(this.$store.state.money);
				return this.$store.state.money;
			},
			activeList() {
				// console.log(this.$store.state.activeList);
				return this.$store.state.activeList;
			},
		},
		data() {
			return {
				showList: false,
				infoList: [],
				isShow: true,
				texType: localStorage.getItem("localetype"),
				time: '',

			};
		},
		methods: {
			changeper() {
				this.$router.push({
					path: "/personal",
				});
			},
			handleKefuClick() {
				homeApi.heart("", "")
					.then((data) => {
						if (data.data.kefu_config) {
							window.location.href = data.data.kefu_config
							// window.open(data.data.kefu_config); // 新窗口打开链接
							// 或使用 location.href = data.data.kefu_config 当前页跳转
						}
					})
					.catch((err) => {
						this.$toast.fail(err);
					});
			},
			changeLanguage() {
				this.$router.push({
					path: "/language",
				});
			},
			activechange(active) {
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 1000,
				});
				storeAction.setCurrentUseractiveList(active);
				storeAction.setsessionStorage("activeList", active);
				// console.log(active);
			},
			info() {
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 0,
				});
				homeApi
					.heart("5", "")
					.then((data) => {
						this.infoList = data.data.hit_notice;
						this.$toast.clear();
					})
					.catch((err) => {
						// alert(err)
						// this.$toast.clear();
						this.$toast.fail(err);
					});
			},
			changeNews() {
				this.$router.push({
					path: "/moreNews",
				});
			},
		},
		mounted() {

		},
		created() {
			let myDate = new Date();
			let time = myDate.toLocaleDateString();
			this.time = time.slice(0)
			this.info();
		},
	};
</script>


<style lang="less" scoped>
	.oadcast {
		overflow: hidden;
		/* 隐藏溢出内容 */
		white-space: nowrap;
		/* 禁止文本换行 */


	}


	@keyframes scrollText {
		0% {
			transform: translateX(100%);
		}

		100% {
			transform: translateX(-100%);
		}
	}

	.text-gold {
		color: #b8a78a;
	}

	.home {
		height: 100%;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
	}

	.g-header {
		display: flex;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		position: absolute;
		width: 100%;
		height: 1.18rem;
		text-align: center;
		// background: red;
		// background: rgb(14, 21, 48);
		z-index: 9999;
		font-size: 0.35rem;
		// color: #fff;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.block {
		height: 1.18rem;
	}

	.navleft,
	.navright {
		display: flex;
		z-index: 11;
		position: absolute;
		height: 100%;
		align-items: center;
	}

	.middle {
		z-index: 10;
		max-width: 80%;
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.fs-18 {
		font-size: 0.36rem;
	}

	.navright {
		right: 0.2rem;
	}

	.app-line {
		padding: 0 0.2rem;
	}

	.broadcast {
		overflow: hidden;
		/* 隐藏溢出内容 */
		white-space: nowrap;
		/* 禁止文本换行 */
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
		margin-top: -25px;
		margin-top: 10px;
		border-radius: 8px;
		margin: 10px auto;
		width: 96%;
		border: 1px solid #b8a78a;
		min-height: 40px;
		padding: 0.2rem 0.4rem;
		display: flex;
		align-items: center;
		/* background-color: #fff; */
		/* line-height: 40px; */
		box-shadow: 3px 3px 3px rgba(26, 26, 26, 0.2);
	}

	.broadcast-icon {

		position: relative;
		margin-right: 0.2rem;
	}

	.sprite-icon_gonggao {
		background: url("../assets/image/duo.png");
		width: 0.49rem;
		height: 0.49rem;
		background-size: 2.53913043rem 2.3026087rem;
		background-position: -1rem 0.9rem;
	}

	.c_a0a0a0 {

		display: inline-block;
		padding-left: 20px;
		/* 与图标间距 */
		animation: scrollText 15s linear infinite;
		/* 15秒循环滚动 */
		color: #fbbd08;
	}

	.cont-head {
		display: flex;
		justify-content: space-between;
		align-items: stretch;
		margin-top: 0.2rem;
		padding: 0 0.2rem;
	}

	.cont-left {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
		border-radius: 5px;
		border: 1px solid rgb(184, 167, 138);
		height: 100%;
		width: 50%;
		margin-right: 0.3rem;
		padding: 0.3rem 0.2rem;

	}

	.en-text {
		font-size: 12px;
		line-height: 20px;
		color: #b8a78a;
		margin-top: 5px;
	}

	.left-text {
		font-size: 12px;
		color: rgb(184, 167, 138);
		font-weight: bold;

	}

	.icon {
		width: 1.10rem;
		height: 1.10rem;
	}

	.cont-right {
		width: 50%;
	}

	.huobin {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
		border-radius: 5px;
		border: 1px solid rgb(184, 167, 138);
		height: 100%;
	}

	.rightcion {
		margin-top: 0.3rem;
		width: 1.10rem;
		height: 1.10rem;
	}

	.menu-container {
		display: flex;
		justify-content: space-between;
		margin-top: 0.2rem;
		padding: 0 0.2rem;
	}

	.prize-news-wrap {
		// padding-bottom: 50px;
		margin-top: 0.2rem;
	}

	.sub-title {
		margin: auto;
		border-radius: 5px;
		width: 96%;
		display: flex;
		text-align: center;
		font-size: 14px;
		color: #b8a78a;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		flex: 1;
		padding: 0.1rem 0 0.1rem;

		span {
			flex: 1;
			padding: 0.1rem 0 0.2rem;
		}
	}

	.prize-news {
		margin: auto;
		border-radius: 5px;
		width: 96%;
		display: flex;
		text-align: center;
		font-size: 14px;
		// color: #b8a78a;
		// background-image: linear-gradient(45deg, #191a1a, #8799a3);
		flex: 1;
		padding: 0.1rem 0 0.1rem;
	}

	.prize-marquee {
		height: 150px !important;
		font-size: 14px;
	}

	.vux-marquee {
		width: 100%;
		overflow: hidden;
		height: 300px;
	}

	.vux-marquee-box {
		padding: 0;
		margin: 0;
		width: 100%;
		height: auto;
	}

	.prize-marquee-item:nth-child(odd) {
		border-radius: 5px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		margin: 3px;
		height: 40px;
		line-height: 40px;
		display: flex;
		align-items: center;
		-ms-flex-pack: distribute;
		justify-content: space-around;
	}

	.prize-marquee-item:nth-child(even) {
		border-radius: 5px;
		background-image: linear-gradient(45deg, #0d99e6, #191a1a);
		margin: 3px;
		height: 40px;
		line-height: 40px;
		display: flex;
		align-items: center;
		-ms-flex-pack: distribute;
		justify-content: space-around;
	}

	.prize-marquee-item span {
		display: inline-block;
		text-align: center;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		flex: 1;
	}

	.prize-marquee-item .name,
	.prize-marquee-item .money {
		color: #b8a78a;
	}

	.prize-marquee-item .type,
	.prize-marquee-item .date {
		color: #b8a78a;
	}

	.content {
		position: absolute;
		width: 100%;
		background: #1a243f;
		top: 1.18rem;
		z-index: 12;
	}

	.line-content {
		background-color: #040925;
	}

	.line-content .line-item {
		height: 1rem;
		font-size: 0.35rem;
		padding: 0 0.4rem 0 0.2rem;
		display: flex;
		align-items: center;
	}

	.line-item :after {
		content: " ";
		position: absolute;
		left: 0;
		bottom: 0;
		right: 0;
		height: 1px;
		border-bottom: 1px solid #3d5179;
		color: #3d5179;
		-webkit-transform-origin: 0 100%;
		transform-origin: 0 100%;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
	}

	.line-item .icon {
		margin-left: 0.4rem;
		width: 1.10rem;
		height: 1.10rem;
	}

	.angleRotestow {
		transform: rotate(180deg);
		transition: transform 0.3s, -webkit-transform 0.3s;
	}

	.icon-arrow-bottoms {
		transform: rotate(0);
		transition: transform 0.3s;
	}
</style>